export default __webpack_public_path__ + "static/media/ct.d3b918b2.png";